import { allocateBomConsumption } from './consumption.js';
import groupLotsByItem from './groupLotsByItem.js';
import Lot, { lotSchema } from './lot.js';
import { formatLotCode, lotDateKey } from './lotCode.js';
import LotCounter, { lotCounterSchema } from './lotCounter.js';
import LotEvent, { lotEventSchema } from './lotEvent.js';
import LotInspection, { lotInspectionSchema } from './lotInspection.js';

function lotFromFirestore(doc) {
  const docData = { id: doc.id, ...doc.data() };
  try {
    return Lot.fromFirestore(docData);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error transforming lot data:', docData.id, error);
    return { validation: 'failed', ...docData };
  }
}

function lotToFirestore(lot, serverTimestamp) {
  if (!serverTimestamp) {
    throw new Error('Missing serverTimestamp function');
  }
  return new Lot(lot).toFirestore({ serverTimestamp });
}

function lotInspectionFromFirestore(doc) {
  const docData = { id: doc.id, ...doc.data() };
  try {
    return LotInspection.fromFirestore(docData);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error transforming inspection data:', docData.id, error);
    return { validation: 'failed', ...docData };
  }
}

function lotInspectionToFirestore(inspection, serverTimestamp) {
  if (!serverTimestamp) {
    throw new Error('Missing serverTimestamp function');
  }
  return new LotInspection(inspection).toFirestore({ serverTimestamp });
}

function lotCounterFromFirestore(doc) {
  const docData = { id: doc.id, ...doc.data() };
  try {
    return LotCounter.fromFirestore(docData);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error transforming lot counter data:', docData.id, error);
    return { validation: 'failed', ...docData };
  }
}

function lotCounterToFirestore(lotCounter, serverTimestamp) {
  if (!serverTimestamp) {
    throw new Error('Missing serverTimestamp function');
  }
  return new LotCounter(lotCounter).toFirestore({ serverTimestamp });
}

function lotEventFromFirestore(doc) {
  const docData = { id: doc.id, ...doc.data() };
  try {
    return LotEvent.fromFirestore(docData);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error transforming lot event data:', docData.id, error);
    return { validation: 'failed', ...docData };
  }
}

function lotEventToFirestore(lotEvent, serverTimestamp) {
  if (!serverTimestamp) {
    throw new Error('Missing serverTimestamp function');
  }
  return new LotEvent(lotEvent).toFirestore({ serverTimestamp });
}

export {
  allocateBomConsumption,
  formatLotCode,
  groupLotsByItem,
  Lot,
  LotCounter,
  lotCounterFromFirestore,
  lotCounterSchema,
  lotCounterToFirestore,
  lotDateKey,
  LotEvent,
  lotEventFromFirestore,
  lotEventSchema,
  lotEventToFirestore,
  lotFromFirestore,
  LotInspection,
  lotInspectionFromFirestore,
  lotInspectionSchema,
  lotInspectionToFirestore,
  lotSchema,
  lotToFirestore,
};
